import { r as registerInstance, h } from './index-16dc7dde.js';
import { t as tryParse } from './parsers-e38ff6a5.js';

const categoryListingMainCss = ":host{display:block;box-sizing:border-box;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}";

let CategoryListingMain = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.hideHMCBanner = false;
    this.navigationState = '';
    this.showBuyOnline = true;
    this.enableCommerceConnector = true;
    this.avoidAccents = false;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    this.localeCode = (_a = tryParse(this._localeCode)) !== null && _a !== void 0 ? _a : this.localeCode;
    this.subcategorySection = (_b = tryParse(this._subcategorySection)) !== null && _b !== void 0 ? _b : this.subcategorySection;
    this.productsSection = (_c = tryParse(this._productsSection)) !== null && _c !== void 0 ? _c : this.productsSection;
    this.filtersSection = (_d = tryParse(this._filtersSection)) !== null && _d !== void 0 ? _d : this.filtersSection;
    this.hmcBanner = (_e = tryParse(this._hmcBanner)) !== null && _e !== void 0 ? _e : this.hmcBanner;
    this.hideHMCBanner = (_f = tryParse(this._hideHMCBanner)) !== null && _f !== void 0 ? _f : this.hideHMCBanner;
    this.navigationState = (_g = tryParse(this._navigationState)) !== null && _g !== void 0 ? _g : this.navigationState;
    this.filtersUrl = (_h = tryParse(this._filtersUrl)) !== null && _h !== void 0 ? _h : this.filtersUrl;
    this.productsUrl = (_j = tryParse(this._productsUrl)) !== null && _j !== void 0 ? _j : this.productsUrl;
    this.rangesUrl = (_k = tryParse(this._rangesUrl)) !== null && _k !== void 0 ? _k : this.rangesUrl;
    this.numberOfProducts = (_l = tryParse(this._numberOfProducts)) !== null && _l !== void 0 ? _l : this.numberOfProducts;
    this.showDocuments = (_m = tryParse(this._showDocuments)) !== null && _m !== void 0 ? _m : this.showDocuments;
    this.showBuyOnline = (_o = tryParse(this._showBuyOnline)) !== null && _o !== void 0 ? _o : this.showBuyOnline;
    this.enableCommerceConnector = (_p = tryParse(this._enableCommerceConnector)) !== null && _p !== void 0 ? _p : this.enableCommerceConnector;
    this.avoidAccents = (_q = tryParse(this._avoidAccents)) !== null && _q !== void 0 ? _q : this.avoidAccents;
    this.hiddenSubcategoriesInfo = (_r = tryParse(this._hiddenSubcategoriesInfo)) !== null && _r !== void 0 ? _r : this.hiddenSubcategoriesInfo;
  }
  render() {
    return (h("pes-category-subcategory-listing", { localeCode: this.localeCode, subcategorySection: this.subcategorySection, productsSection: this.productsSection, filtersSection: this.filtersSection, hmcBanner: this.hmcBanner, hideHMCBanner: this.hideHMCBanner, navigationState: this.navigationState, filtersUrl: this.filtersUrl, productsUrl: this.productsUrl, rangesUrl: this.rangesUrl, numberOfProducts: this.numberOfProducts, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, enableCommerceConnector: this.enableCommerceConnector, avoidAccents: this.avoidAccents, hiddenSubcategoriesInfo: this.hiddenSubcategoriesInfo, pageParam: this.pageParam }));
  }
};
CategoryListingMain.style = categoryListingMainCss;

export { CategoryListingMain as pes_category_listing_main };
